module.exports = __webpack_public_path__ + "static/img/send.2393765d.svg";